export const OFFER_SPECIFIC_CHAR_LIMIT = 1000;
export const CANCELLATION_POLICY_OPTIONS = ["flexible", "moderate", "strict"];
export const CANCELLATION_POLICY_OPTIONS_WITH_CUSTOM = CANCELLATION_POLICY_OPTIONS.concat("custom");
export const VAT_PERCENT_BASA = 19;
